/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugEmbeddedClientConnector = void 0;
const events_1 = require("events");
const ButtplugServer_1 = require("../server/ButtplugServer");
const ButtplugClientConnectorException_1 = require("./ButtplugClientConnectorException");
class ButtplugEmbeddedClientConnector extends events_1.EventEmitter {
    constructor() {
        super(...arguments);
        this._connected = false;
        this._server = null;
        this.Connect = () => __awaiter(this, void 0, void 0, function* () {
            this._connected = true;
            if (this._server === null) {
                this._server = new ButtplugServer_1.ButtplugServer();
            }
            this._server.addListener("message", this.OnMessageReceived);
        });
        this.Disconnect = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._connected) {
                return;
            }
            try {
                // If we're shutting down but this rejects (due to the device manager
                // throwing while shutting down devices), rethrow but finish shutting down
                // first. We should just assume the server is dead no matter what.
                yield this._server.Shutdown();
            }
            finally {
                this._connected = false;
                this._server = null;
                this.emit("disconnect");
            }
        });
        this.Send = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (!this._connected) {
                throw new ButtplugClientConnectorException_1.ButtplugClientConnectorException("Client not connected.");
            }
            return yield this._server.SendMessage(aMsg);
        });
        this.OnMessageReceived = (aMsg) => {
            this.emit("message", [aMsg]);
        };
    }
    set Server(server) {
        this._server = server;
    }
    get Server() {
        return this._server;
    }
    Initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
    }
    get Connected() {
        return this._connected;
    }
}
exports.ButtplugEmbeddedClientConnector = ButtplugEmbeddedClientConnector;
//# sourceMappingURL=ButtplugEmbeddedClientConnector.js.map